import type { AdditionalFieldValues } from "@bbj-types/candidate";
import type { ObjectId } from "@bbj-types/utils";
import type { DifficultyCoachingLevel } from "@inputs/DifficultyToggleGroup";
import { useCallback } from "react";
import { useAxiosDiagnosis } from "../../axios";
import type { IDiagnosisApplicationFiles, IDiagnosisCandidateChallenge, IDiagnosisCandidateFields } from "../../types";

export interface IPutCandidateDraftDiagnosisBody {
  candidateFields: IDiagnosisCandidateFields;
  candidateDynamicFields: Record<string, AdditionalFieldValues>;
  applicationFiles: IDiagnosisApplicationFiles;
  difficulties: Record<string, DifficultyCoachingLevel>;
  challenges: IDiagnosisCandidateChallenge[];
  comment: string;
  completed: boolean;
  timeSpent?: number;
  contactChannel?: string;
}

export const usePutCandidateDraftDiagnosis = () => {
  const [state, execute, cancel] = useAxiosDiagnosis<void, IPutCandidateDraftDiagnosisBody>(
    {
      method: "PUT",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (candidateId: ObjectId, diagnosis: IPutCandidateDraftDiagnosisBody) =>
      execute({
        url: `/draft/candidate/${candidateId}`,
        data: diagnosis,
      }),
    [execute]
  );

  return [state, callback, cancel] as const;
};
